module.exports = __webpack_public_path__ + "img/stuff.b78f4803.png";